import React, { Fragment } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { Radio, RadioGroup, FormControlLabel } from '@mui/material';

const RadioInput = ({ input, options, variant, isLoading, disabled, ...props }) => {
    const locked = !!(isLoading || disabled);
    const handleChange = (event) => {
        if (locked) return;
        const value = event.target.value;
        input.onChange(value ? value : null);
    };

    if (variant === 'cards') {
        return (
            <div className={locked ? 'pc-opts-wrap is-off' : 'pc-opts-wrap'}>
                {props.label && (
                    <div className="pc-field__label" style={{ marginBottom: 8 }}>{props.label}</div>
                )}
                <div className={props.columns === 5 ? 'pc-opts pc-opts--5' : 'pc-opts'}>
                    {(options || []).map((opt, index) => {
                        const selected = input.value === opt.id;
                        return (
                            <label key={index} className={`pc-opt${selected ? ' is-sel' : ''}${locked ? ' is-off' : ''}`}>
                                <input
                                    type="radio"
                                    checked={selected}
                                    onChange={handleChange}
                                    value={opt.id}
                                    name={input.name}
                                    disabled={locked}
                                />
                                <span>
                                    <b>{opt.name}</b>
                                    {opt.hint ? <span>{opt.hint}</span> : null}
                                </span>
                            </label>
                        );
                    })}
                </div>
            </div>
        );
    }

    return (
        <FormControlLabel
            value="top"
            control={
                <RadioGroup row aria-label="position" name="position" defaultValue="top">
                    {(options && options.length > 0) &&
                        options.map((opt, index) =>
                            <Fragment key={index}>
                                <Radio
                                    checked={input.value === opt.id}
                                    onChange={handleChange}
                                    value={opt.id}
                                    color="primary"
                                    name="radio-button-demo"
                                    disabled={locked}
                                    inputProps={{ 'aria-label': 'A' }}
                                />
                                <label style={{ paddingTop: '0.5rem', letterSpacing: '0.00938em' }}>
                                    {opt.name}
                                </label>
                            </Fragment>
                        )
                    }
                </RadioGroup>
            }
            label={props.label}
            labelPlacement="top"
        />
    );
};

const mapStateToProps = (state) => {
    const { fetch } = state;
    return {
        isLoading: !!fetch.loading
    };
};

export default compose(
    connect(mapStateToProps),
)(RadioInput);
